export const ENV = {
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL || '/api',
  MSAL_CLIENT_ID: import.meta.env.VITE_MSAL_CLIENT_ID || '',
  MSAL_TENANT_ID: import.meta.env.VITE_MSAL_TENANT_ID || 'common',
  MSAL_AUTHORITY: import.meta.env.VITE_MSAL_AUTHORITY ||
    `https://login.microsoftonline.com/${import.meta.env.VITE_MSAL_TENANT_ID || 'common'}`,
  MSAL_REDIRECT_URI: import.meta.env.VITE_MSAL_REDIRECT_URI || 'http://localhost:5173',
  APP_NAME: 'QHRMS',
  APP_VERSION: '1.0.0',
  IS_PRODUCTION: import.meta.env.PROD,
  IS_DEVELOPMENT: import.meta.env.DEV,
} as const;
